import * as React from 'react';
import WebGLDirector from './WebGLDirector';
import WebGLPolygon from './shapes/primitives/WebGLPolygon';
import Color from './Color';
import WebGLComposition from './shapes/composites/WebGLComposition';

export default class PolygonsComponent extends React.Component<{size: number}, void> {

	private canvas: HTMLCanvasElement;
	private textOverlay: HTMLDivElement;

	componentDidMount () {
		const director = new WebGLDirector(this.canvas, this.props.size, this.props.size, this.textOverlay);

		const grass = WebGLPolygon.fromNumbers([-1, -1, -1, -.8, 1, -.8, 1, -1]).setColor(Color.green());

		const blockPrototype = WebGLPolygon.fromNumbers([-100, 100, 100, 100, 100, -100, -100, -100]).setColor(Color.blueMatte());
		const leftBlock = blockPrototype.copy().scale(1 / 1000).translate(-725, -200, 0);
		const rightBlock = blockPrototype.copy().scale(1 / 1000).translate(725, -200, 0);

		const contraptionPrototype = WebGLPolygon.fromNumbers([-200, 200, 200, 200, 200, -200, -200, -200]).scale(1 / 1000).setColor(Color.red());
		const leftContraption = contraptionPrototype.copy().translate(-725, -600, 0);
		const rightContraption = contraptionPrototype.copy().translate(725, -600, 0);

		const pinShaft = WebGLPolygon.fromNumbers([-25, 0, -25, 175, 25, 175, 25, 0]).scale(1 / 1000);
		const pinPlatform = WebGLPolygon.fromNumbers([-75, 175, -75, 200, 75, 200, 75, 175]).scale(1 / 1000);
		const pinPrototype = new WebGLComposition([pinShaft, pinPlatform]).setColor(Color.yellow());
		const leftVerticalPin = pinPrototype.copy().translate(-725, -500, 0);
		const leftHorizontalPin = pinPrototype.copy().translate(-625, -700, 0);
		const rightVerticalPin = pinPrototype.copy().translate(725, -500, 0);
		const rightHorizontalPin = pinPrototype.copy().translate(648, -700, 0);

		const ball = WebGLPolygon.circle(-325, -700, 100, 128).scale(1 / 1000).setColor(Color.blueMatte());

		const leftBlockBaseMatrix = leftBlock.getTransformationMatrix();
		const rightBlockBaseMatrix = rightBlock.getTransformationMatrix();

		const leftVerticalPinMatrix = (leftVerticalPin.getComponents()[0] as WebGLPolygon).getTransformationMatrix();
		const leftHorizontalPinMatrix = (leftHorizontalPin.getComponents()[0] as WebGLPolygon).getTransformationMatrix();
		const rightVerticalPinMatrix = (rightVerticalPin.getComponents()[0] as WebGLPolygon).getTransformationMatrix();
		const rightHorizontalPinMatrix = (rightHorizontalPin.getComponents()[0] as WebGLPolygon).getTransformationMatrix();
		const ballMatrix = ball.getTransformationMatrix();

		director.addShapes([grass, leftBlock, rightBlock, leftVerticalPin, leftHorizontalPin, rightVerticalPin, rightHorizontalPin, leftContraption, rightContraption, ball]);

		let time = 0;
		let leftBlockHeight = 1035;
		let leftBlockSpeed = 0;
		let ballX = 0;
		let ballSpeed = 0;
		let rightBlockHeight = 0;
		let rightBlockSpeed = 0;

		let leftVerticalPinHeight = 89;
		let leftHorizontalPinX = 0;
		let rightVerticalPinHeight = 0;
		let rightHorizontalPinX = -89;

		director.drawScene();
		setInterval(() => {
				time++;

				if (time <= 45) {
					leftBlockSpeed--;

					if (time > 43) {
						ballSpeed = -leftBlockSpeed;
						leftVerticalPinHeight += leftBlockSpeed;
						leftHorizontalPinX -= leftBlockSpeed;
					}
				}

				if (time === 46) {
					leftBlockSpeed = 0;
				}

				if (time === 58 || time === 59) {
					rightHorizontalPinX += ballSpeed;
					rightVerticalPinHeight += ballSpeed;

					ballSpeed = time === 58 ? 44 : 0;

					if (time === 58) {
						rightBlockSpeed = 45;
					}
				}

				if (time > 58 && time < 149) {
					rightBlockSpeed--;
				}

				if (time === 148) {
					rightVerticalPinHeight -= 44;
					rightHorizontalPinX -= 44;
					ballSpeed = -44;
				}

				if (time === 149) {
					rightBlockSpeed = 0;
					rightVerticalPinHeight -= 45;
					rightHorizontalPinX -= 45;
					ballSpeed = -45;
				}

				if (time === 162 || time === 163) {
					leftHorizontalPinX += ballSpeed;
					leftVerticalPinHeight -= ballSpeed;

					ballSpeed = time === 162 ? -44 : 0;

					if (time === 162) {
						leftBlockSpeed = 45;
					}
				}

				if (time >= 163 && time <= 207) {
					leftBlockSpeed--;

					if (time === 207) {
						time = 0;
					}
				}

				leftBlockHeight += leftBlockSpeed;
				ballX += ballSpeed;
				rightBlockHeight += rightBlockSpeed;

				leftBlock.setTransformationMatrix(leftBlockBaseMatrix.copy().translateY(leftBlockHeight));
				rightBlock.setTransformationMatrix(rightBlockBaseMatrix.copy().translateY(rightBlockHeight));

				leftVerticalPin.setTransformationMatrix(leftVerticalPinMatrix.copy().translateY(leftVerticalPinHeight));
				leftHorizontalPin.setTransformationMatrix(leftHorizontalPinMatrix.copy().translateX(leftHorizontalPinX).rotateZ(-Math.PI / 2));

				rightVerticalPin.setTransformationMatrix(rightVerticalPinMatrix.copy().translateY(rightVerticalPinHeight));
				rightHorizontalPin.setTransformationMatrix(rightHorizontalPinMatrix.copy().translateX(rightHorizontalPinX).rotateZ(Math.PI / 2));

				ball.setTransformationMatrix(ballMatrix.copy().translateX(ballX));

				// Matrix.translate(leftBlock.getTransformationMatrix(), leftBlockBaseMatrix, Vector.fromValues(0, leftBlockHeight, 0));
				// Matrix.translate(rightBlock.getTransformationMatrix(), rightBlockBaseMatrix, Vector.fromValues(0, rightBlockHeight, 0));
				//
				// Matrix.translate((leftVerticalPin.getComponents()[0] as PrimitiveShape).getTransformationMatrix(), leftVerticalPinMatrix, Vector.fromValues(0, leftVerticalPinHeight, 0));
				// Matrix.translate((leftVerticalPin.getComponents()[1] as PrimitiveShape).getTransformationMatrix(), leftVerticalPinMatrix, Vector.fromValues(0, leftVerticalPinHeight, 0));
				// Matrix.translate((leftHorizontalPin.getComponents()[0] as PrimitiveShape).getTransformationMatrix(), leftHorizontalPinMatrix, Vector.fromValues(leftHorizontalPinX, 0, 0));
				// Matrix.translate((leftHorizontalPin.getComponents()[1] as PrimitiveShape).getTransformationMatrix(), leftHorizontalPinMatrix, Vector.fromValues(leftHorizontalPinX, 0, 0));
				// Matrix.rotateZ((leftHorizontalPin.getComponents()[0] as PrimitiveShape).getTransformationMatrix(), (leftHorizontalPin.getComponents()[0] as PrimitiveShape).getTransformationMatrix(), -Math.PI / 2);
				// Matrix.rotateZ((leftHorizontalPin.getComponents()[1] as PrimitiveShape).getTransformationMatrix(), (leftHorizontalPin.getComponents()[1] as PrimitiveShape).getTransformationMatrix(), -Math.PI / 2);
				//
				// Matrix.translate((rightVerticalPin.getComponents()[0] as PrimitiveShape).getTransformationMatrix(), rightVerticalPinMatrix, Vector.fromValues(0, rightVerticalPinHeight, 0));
				// Matrix.translate((rightVerticalPin.getComponents()[1] as PrimitiveShape).getTransformationMatrix(), rightVerticalPinMatrix, Vector.fromValues(0, rightVerticalPinHeight, 0));
				// Matrix.translate((rightHorizontalPin.getComponents()[0] as PrimitiveShape).getTransformationMatrix(), rightHorizontalPinMatrix, Vector.fromValues(rightHorizontalPinX, 0, 0));
				// Matrix.translate((rightHorizontalPin.getComponents()[1] as PrimitiveShape).getTransformationMatrix(), rightHorizontalPinMatrix, Vector.fromValues(rightHorizontalPinX, 0, 0));
				// Matrix.rotateZ((rightHorizontalPin.getComponents()[0] as PrimitiveShape).getTransformationMatrix(), (rightHorizontalPin.getComponents()[0] as PrimitiveShape).getTransformationMatrix(), Math.PI / 2);
				// Matrix.rotateZ((rightHorizontalPin.getComponents()[1] as PrimitiveShape).getTransformationMatrix(), (rightHorizontalPin.getComponents()[1] as PrimitiveShape).getTransformationMatrix(), Math.PI / 2);
				//
				// Matrix.translate(ball.getTransformationMatrix(), ballMatrix, Vector.fromValues(ballX, 0, 0));

				director.drawScene();
			}, 16
		);
	}

	render () {
		const pixelSize = this.props.size + 'px';
		const renderSize = this.props.size * 2;

		return (
			<div style={{position: 'relative', width: pixelSize, margin: 'auto'}}>
				<canvas ref={element => this.canvas = element} width={renderSize} height={renderSize} style={{width: pixelSize, height: pixelSize}} />
				<div ref={element => this.textOverlay = element} style={{position: 'absolute', top: 0, width: pixelSize, height: pixelSize}} />
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./code/project/pages/components/webGL/PolygonsComponent.tsx